import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import { cellDateOperation } from '../../../helpers/tables';
import 'styles/modal.css';

const fmt = (val) =>
  val != null ? val.toLocaleString('es-CL', { minimumFractionDigits: 2 }) : '—';

const SiniestrosModal = ({ isOpen, onClose, siniestros, moneda }) => (
  <Modal isOpen={isOpen} toggle={onClose} size="xl" className="liquidacion-modal liquidacion-modal--wide">
    <ModalHeader toggle={onClose}>
      Detalle de Siniestros Pagados
    </ModalHeader>
    <ModalBody className="liquidacion-modal__body">
      {siniestros.length === 0 ? (
        <p style={{ padding: '1rem', color: 'var(--color-text-secondary)' }}>
          Sin siniestros pagados para esta selección.
        </p>
      ) : (
        <Table hover responsive bordered size="sm" className="liquidacion-modal__table">
          <thead>
            <tr>
              <th>ID Interno</th>
              <th>RUT Deudor</th>
              <th>Nemotécnico</th>
              <th>Nombre Asegurado</th>
              <th>Nombre Deudor</th>
              <th>Fecha Denuncio</th>
              <th>Vigencia</th>
              <th className="text-right">Monto Denunciado</th>
              <th className="text-right">Monto Pagado ({moneda})</th>
            </tr>
          </thead>
          <tbody>
            {siniestros.map((s) => (
              <tr key={s.id}>
                <td>{s.id_interno || '—'}</td>
                <td>{s.cliente_rut || '—'}</td>
                <td>{s.poliza || '—'}</td>
                <td>{s.asegurado_nombre || '—'}</td>
                <td>{s.nombre_deudor || '—'}</td>
                <td>{cellDateOperation(s.fecha_denuncio)}</td>
                <td className="text-center">{(s.vigencias || []).join(', ') || '—'}</td>
                <td className="text-right">{fmt(s.monto_denunciado)}</td>
                <td className="text-right">{fmt(s.monto_pagado)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </ModalBody>
  </Modal>
);

SiniestrosModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  siniestros: PropTypes.array.isRequired,
  moneda: PropTypes.string,
};

SiniestrosModal.defaultProps = {
  moneda: 'UF',
};

export default SiniestrosModal;